module.exports = __webpack_public_path__ + "img/5451877202183446144.defe2dd8.jpg";